import React from 'react';
import { Link } from 'react-router-dom';
import {
  Phone,
  MapPin,
  Instagram,
  Clock,
  Facebook
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* Brand */}
          <div className="space-y-4">
            <img
              src="/lor95.png"
              alt="Lor95 Boutique"
              className="h-16 w-auto object-contain"
            />

            <p className="text-sm text-gray-400">
              Ngrini stilin tuaj me Lor95 Boutique - modë për femra dhe meshkuj me dërgesa në të gjithë Shqipërinë.
            </p>
          </div>


          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Lidhje të Shpejta
            </h3>

            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm hover:text-white transition-colors"
                >
                  Kryefaqja
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  className="text-sm hover:text-white transition-colors"
                >
                  Rreth Nesh
                </Link>
              </li>

              <li>
                <Link
                  to="/collections"
                  className="text-sm hover:text-white transition-colors"
                >
                  Koleksionet
                </Link>
              </li>

              <li>
                <Link
                  to="/visit"
                  className="text-sm hover:text-white transition-colors"
                >
                  Na Vizitoni
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="text-sm hover:text-white transition-colors"
                >
                  Kontakti
                </Link>
              </li>
            </ul>
          </div>


          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Na Kontaktoni
            </h3>

            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  Rruga Desaret, Berat 5001, Shqipëri
                </span>
              </li>

              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-gray-400 flex-shrink-0" />

                <a
                  href="tel:+355693520111"
                  className="text-sm hover:text-white transition-colors"
                >
                  +355 69 352 0111
                </a>
              </li>

              <li className="flex items-start space-x-2">
                <Clock className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" />

                <span className="text-sm">
                  Hapur çdo ditë
                  <br />
                  Mbyllet në orën 21:00
                </span>
              </li>
            </ul>
          </div>


          {/* Social */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Na Ndiqni
            </h3>

            <div className="space-y-4">

              <a
                href="https://www.instagram.com/lor_95_boutique/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-sm hover:text-white transition-colors group"
              >
                <Instagram className="h-5 w-5 group-hover:scale-110 transition-transform" />
                <span>@lor95boutique</span>
              </a>

              <br />

              <a
                href="https://www.facebook.com/p/Lor-95-Boutique-100086001116286/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-sm text-gray-400 hover:text-[#1877F2] transition-colors group"
              >
                <Facebook className="h-5 w-5 group-hover:scale-110 transition-transform" />
                <span>Lor 95 Boutique</span>
              </a>

              <p className="text-sm text-gray-400">
                Na ndiqni në Instagram dhe Facebook për koleksionet tona të fundit dhe njoftimet e reja!
              </p>

            </div>
          </div>

        </div>


        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <p className="text-sm text-gray-400 text-center">
            © {new Date().getFullYear()} Lor95 Boutique. Të gjitha të drejtat e rezervuara.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
